<template>
<div class="">
    <div class="header-body" style="background-color: #F1F2F3;height: 220px;">
        <ul class="progress-tracker progress-tracker--text progress-tracker--center pt-3"  >
            <li class="progress-step is-active">
                <div class="progress-marker"></div>
                <div class="progress-text">
                    <span id="search-icon">
                        <i class="fas fa-search" ></i>
                    </span>
                    <small class="progress-title pb-0" style="font-size: 16px">Search</small><br>
                    <small>Search your favorite room</small>
                </div>
            </li>
            <li class="progress-step" :class="secondProgress || third_progress?'is-active':''">
                <div class="progress-marker"></div>
                <div class="progress-text">
                    <i class="fas fa-calendar-check"></i>
                    <small class="progress-title pb-0" style="font-size: 16px">Booking</small><br>
                    <small>Enter your booking detail</small>
                </div>
            </li>
            <li class="progress-step " :class="third_progress?'is-active':''">
                <div class="progress-marker"></div>
                <div class="progress-text">
                    <i class="fas fa-check-circle"></i>
                    <small class="progress-title pb-0" style="font-size: 13px">Confirmation</small><br>
                    <small>Receive a confirmation</small>
                </div>
            </li>
        </ul>
    </div>
    <el-row v-if="personalPage == false"  class="mt-3 container pl-md-0 pr-md-0 pl-lg-0 pr-lg-0" >
        <el-col  class="col-sm-12 col-md-4 col-xl-2 checkin" >
            <small class="text-muted">Checkin</small><br>
            <el-date-picker @input="validateEndDate" :picker-options="checkinDatePickerOptions" v-model="checkin" type="date"
                            class="datePicker"
                            format="yyyy/MM/dd"
                            value-format="yyyy-MM-dd">
            </el-date-picker>
        </el-col>
        <el-col class="col-sm-12 col-md-4 col-xl-2" >
            <small class="text-muted">Checkout</small><br>
            <el-date-picker v-model="checkout" :picker-options="checkoutDatePickerOptions" @change="searchRooms()"
                            class="datePicker"
                            format="yyyy/MM/dd"
                            value-format="yyyy-MM-dd">
            </el-date-picker>
        </el-col>
        <el-col class="col-sm-12 col-md-4 col-xl-2" >
            <small class="text-muted">Room</small><br>
            <el-select collapse-tags placeholder="  Rooms" class="w-100" v-model="numberOfRooms" name="adult" id="adult" @change="searchRooms()">
                <template slot="prefix"><i class="fas fa-bed ml-2" style="color: orangered; margin-top: 0.7rem!important;"/></template>
                <el-option
                    :label="1"
                    :value="1">
                </el-option>
                <el-option
                    :label="2"
                    :value="2">
                </el-option>
                <el-option
                    :label="3"
                    :value="3">
                </el-option>
                <el-option
                    :label="4"
                    :value="4">
                </el-option>
                <el-option
                    :label="5"
                    :value="5">
                </el-option>
            </el-select>
        </el-col>
        <el-col  class="col-sm-4 col-md-4 col-xl-2">
            <small class="text-muted">Adult</small>
            <el-select collapse-tags placeholder="Adult" class="w-100" v-model="adult" @change="searchRooms()">
                <template slot="prefix"><i class="fas fa-male mt-3 ml-2" style="color: orangered;margin-top: 0.7rem!important;"/></template>
                <el-option
                    :label="1"
                    :value="1">
                </el-option>
                <el-option
                    :label="2"
                    :value="2">
                </el-option>
            </el-select>
        </el-col>
        <el-col  class="col-sm-4 col-md-4 col-xl-2">
            <small class="text-muted">Children</small>
            <el-select  collapse-tags placeholder="Children" class="w-100" v-model="children" name="children" id="children" @change="searchRooms()">
                <template slot="prefix"><i class="fas fa-child mt-3 ml-2 " style="color: orangered;margin-top: 0.7rem!important;"/></template>
                <el-option
                    :label="0"
                    :value="0">
                </el-option>
                <el-option
                    :label="1"
                    :value="1">
                </el-option>
                <el-option
                    :label="2"
                    :value="2">
                </el-option>
            </el-select>
        </el-col>
        <el-col  class="col-sm-4 col-md-4 col-xl-2 infant">
            <small class="text-muted">Infant</small>
            <el-select collapse-tags placeholder="Infants" class="w-100" v-model="infant" name="infant" id="infant"  @change="searchRooms()" >
                <template slot="prefix"> <i class="fas fa-baby mt-3 ml-2" style="color: orangered;margin-top: 0.7rem!important;"/></template>
                <el-option
                    :label="0"
                    :value="0">
                </el-option>
                <el-option
                    :label="1"
                    :value="1">
                </el-option>
                <el-option
                    :label="2"
                    :value="2">
                </el-option>
            </el-select>
        </el-col>
    </el-row>
    <div class="modal fade" id="searchLoadingModal" tabindex="-1" role="dialog" aria-labelledby="searchLoadingModal" aria-hidden="true">
        <div class="modal-dialog" role="document" >
            <div class="modal-content">
                <div class="modal-header text-center">
                    <div class="row">
                        <div class="col-4">
                            <img src="/img/frontend/capital-hotel/loading2.gif" width="100px" height="100px" class="img-circle">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        name: "HeaderComponent",
        components: {
        },
        props : [
            'personalPage',
            'secondProgress',
            'third_progress'
        ],
        data (){
          return {
              searchResult:[],
              loading:Boolean,
              numberOfRooms: 1,
              adult: 1,
              children: 0,
              infant: 0,
              checkin: '',
              checkout: '',
              task: {
                  start_at: '',
                  end_at: ''
              },
              checkinDatePickerOptions: {
                  disabledDate: this.disableDateBefore
              },
              checkoutDatePickerOptions: {
                  disabledDate: this.disabledDueDate
              }
          }
        },
        created() {
            // this.setDate();
            this.getDataFromUrl();
            console.log(this.thirdProgress)
        },
        methods : {
            disabledDueDate (time) {
                return time.getTime() < new Date(this.checkin)
            },
            validateEndDate () {
                if (this.checkin > this.checkout) {
                    this.checkout = this.checkin
                }
            },
            disableDateBefore (time) {
                let date =   new Date();
                let finalDate = new Date(date);
                finalDate.setDate(date.getDate() - 1);
                return time < new Date(finalDate)
            },
            searchRooms : function () {
                let searchFieldValue = {

                    "adult": this.adult,
                    "children":this.children,
                    "infant":this.infant,
                    "checkin":this.checkin,
                    "checkout":this.checkout,
                    "numRoomNeeded":this.numberOfRooms,
                };
                this.$emit('searchFieldValue', searchFieldValue);
            },
            setDate : function () {
                let todayDate = new Date();
                todayDate .setDate(todayDate .getDate() + 1);

                this.checkin = new Date().toISOString().slice(0,10);
                this.checkout = todayDate.toISOString().slice(0,10);
            },
            getDataFromUrl : function () {
                let url_string = window.location;
                let url = new URL(url_string);
                let checkin_monthday = url.searchParams.get("checkin_monthday");
                let checkin_year_month = url.searchParams.get("checkin_year_month");
                let checkout_monthday = url.searchParams.get("checkout_monthday");
                let checkout_year_month = url.searchParams.get("checkout_year_month");
                let group_adults = url.searchParams.get("group_adults");
                let group_children = url.searchParams.get("group_children");
                let no_rooms = url.searchParams.get("no_rooms");


                if(checkin_monthday != null && checkin_year_month != null)
                {
                    let checkin = checkin_year_month +'-'+ checkin_monthday;
                    this.checkin = new Date(checkin).toISOString().slice(0,10);
                }

                if(checkout_monthday != null && checkout_year_month != null)
                {
                    let checkout = checkout_year_month +'-'+ checkout_monthday;
                    this.checkout = new Date(checkout).toISOString().slice(0,10);
                }

                if(group_adults != null)
                {
                    this.adult = group_adults;
                }

                if(group_children != null)
                {
                    this.children = group_children;
                }

                if(no_rooms != null)
                {
                    this.numberOfRooms = no_rooms;
                }

                if(this.checkin == '' && this.checkout == '')
                {
                    this.setDate()
                }
            }

        },
        watch:{
            searchResult:function (newVal,oldVal) {
                this.$emit('searchResult',this.searchResult);
            },

            loading : function (newVal,endVal) {
                $('#searchLoadingModal').modal('hide');
            }
        }
    }
</script>

<style >
    .modal-content {
        margin-top: 50%;
        margin-left: 50%;
        background-color: transparent;
        border: none;

    }
    .modal-header
    {
        background-color: transparent;
        border: none;
    }
    .room-search > li{
        padding-left: 10px;

        /*color: white;*/
    }
    .search-nav{
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .progress-tracker{
        margin-top: 10px !important;
        padding-top: 60px !important;
        padding-bottom: 30px !important;

    }
    /*.progress-marker::before{*/
    /*    background-color: orangered !important;*/
    /*}*/
    .progress-marker{
        z-index: 100;
    }

    .progress-marker::after{
        background-color: lightgray !important;
    }
    .progress-step.is-active .progress-marker::before {
        background-color: #ef6e4a !important;
    }
    .progress-step:hover .progress-marker::before {
        background-color: #ef6e4a !important;
    }
    .header-body{

        border: solid lightgrey 1px;
        /*box-shadow: 0 1px 6px 0 rgba(0, 0,*/
        /*0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);*/

        /*box-shadow: 5px 5px 5px 5px #888888;*/
        /*-moz-box-shadow: 5px 5px 5px #ccc;*/
        /*-webkit-box-shadow: 5px 5px 5px #ccc;*/
        /*-khtml-box-shadow: 105 5px 5px #ccc;*/
    }
    .col-12 {
        padding-left: 0 !important;
    }
    @media(max-height: 1199px) {
        .datePicker{
            width: 90% !important;
        }

    }
    @media (min-width: 1199px) {
        .infant, .checkin{
            padding-left: 0px;
            padding-right: 0px;
        }
    }
    .datePicker{
        width: 100% !important;
    }
    .el-icon-date{
        color: orangered;
    }
    .search-icon{
        position: absolute;
        top: -20px;
    }

</style>
